import { cn } from '@/lib/utils';

interface Props {
  label: string;
  count: number;
  isActive: boolean;
  onSelect: () => void;
  children?: React.ReactNode;
}

export function DriverGroupPill({
  label,
  count,
  isActive,
  onSelect,
  children,
}: Readonly<Props>): React.JSX.Element {
  return (
    <div
      className={cn(
        'relative flex items-center h-7 rounded-full border',
        isActive
          ? 'border-violet-600 bg-violet-600 text-white'
          : 'border-border bg-card text-foreground'
      )}
    >
      <button
        type="button"
        onClick={onSelect}
        className="flex items-center gap-1.5 h-6 px-3 rounded-full text-[13px] font-medium"
      >
        <span>{label}</span>
        <span
          className={cn(
            'text-[11px] font-semibold px-1.5 rounded-full',
            isActive ? 'bg-white/20 text-white' : 'bg-muted text-muted-foreground'
          )}
        >
          {count}
        </span>
      </button>
      {children}
    </div>
  );
}
